import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import AddNew from './pages/AddNew'
import NoMatch from './pages/NoMatch'
import EditTask from './pages/EditTask'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path='/add-new' element={<AddNew />} />
        <Route path='/edit-task/:taskId' element={<EditTask />} />
        <Route path='*' element={<NoMatch />} />
      </Routes>
    </BrowserRouter>
  )
}
